var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header-content" }, [
    _c("div", { staticClass: "header-wrapper" }, [
      _c("img", {
        staticClass: "haike-logo",
        attrs: { src: require("../assets/images/haike-logo.png"), alt: "" }
      }),
      _c(
        "span",
        { staticClass: "header-nav clearfix" },
        [
          _c(
            "router-link",
            {
              staticClass: "title line-below",
              attrs: { to: { name: "Home" }, exact: "" }
            },
            [
              _c("div", { staticClass: "marginLeft home" }, [
                _vm._v("首页"),
                _c("i")
              ])
            ]
          ),
          _c(
            "router-link",
            {
              staticClass: "title line-below",
              attrs: { to: { name: "AboutUs" } }
            },
            [
              _c("div", { staticClass: "marginLeft" }, [
                _vm._v("关于我们"),
                _c("i")
              ])
            ]
          ),
          _c(
            "router-link",
            {
              staticClass: "title line-below",
              attrs: { to: { name: "ProductIndtoduce" } }
            },
            [
              _c("div", { staticClass: "marginLeft" }, [
                _vm._v("产品介绍"),
                _c("i")
              ])
            ]
          ),
          _c(
            "router-link",
            {
              staticClass: "title line-below",
              attrs: { to: { name: "Business" } }
            },
            [
              _c("div", { staticClass: "marginLeft" }, [
                _vm._v("企业动态"),
                _c("i")
              ])
            ]
          ),
          _c(
            "router-link",
            {
              staticClass: "title line-below",
              attrs: { to: { name: "ConnectUs" } }
            },
            [
              _c("div", { staticClass: "marginLeft" }, [
                _vm._v("联系我们"),
                _c("i")
              ])
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }